import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.subCategoryImageClickable = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: center;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    css: css`
        width: 100%;
    `,
    color: "primary",
    typographyProps: {
        css: css`
            width: 100%;
            text-align: center;
            word-wrap: break-word;
            font-family: "LatoBold";
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: left;
                    `,
                    css`
                        text-align: left;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};
